import { reactive } from 'vue';

import Breakpoints from 'lg-vue-components/utils/breakpoints';

const DEFAULT_OPTIONS = {
  fhdOnly: false,

  xlOnly: false,
  xlAndDown: false,
  xlAndUp: false,

  lgOnly: false,
  lgAndDown: false,
  lgAndUp: false,

  mdOnly: false,
  mdAndDown: false,
  mdAndUp: false,

  smOnly: false,
  smAndDown: false,
  smAndUp: false,

  xsOnly: false,

  width: 0,
  height: 0,
};

const BreakMonitor = {
  install(app) {
    if (!app) {
      return;
    }

    /* eslint-disable */
    app.config.globalProperties.$lg = app.config.globalProperties.$lg || {};
    app.config.globalProperties.$lg.breakpoint = reactive(DEFAULT_OPTIONS);
    /* eslint-enable */

    this.inicialize(app);
  },

  inicialize(app) {
    const updateModel = (newValues) => {
      Object.keys(DEFAULT_OPTIONS).forEach((x) => {
        // eslint-disable-next-line
        app.config.globalProperties.$lg.breakpoint[x] = newValues[x];
      });
    };

    this.breakInstance = new Breakpoints(updateModel);
  },
};

export default BreakMonitor;
